import { render } from "./DraggableComponent.vue?vue&type=template&id=6b51a4f8"
import script from "./DraggableComponent.vue?vue&type=script&lang=js"
export * from "./DraggableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__